import React from 'react'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'
import qs from 'qs'
import buscarReserva from '../../actions/reserva/buscarReserva'
import { formatarReal } from '../../util/numberUtil'
import { showErrorMsg } from '../../util/messagesUtil'

const TEXTO_LEGAL_REEMBOLSO = (
  <React.Fragment>
    <p className="mb-2">
      <small>
        (Lei nº 11.975 de 07/07/2009) - Resolução nº 4.282 de 17 de fevereiro de 2014.
      </small>
    </p>
    <p className="mb-2">
      <small>
        Nos casos de solicitação de reembolso do valor pago do bilhete por desistência do usuário, a transportadora
        disporá de até 30 (trinta) dias a partir da data do pedido, para efetivar a devolução, com retenção de 5%.
      </small>
    </p>
    <p className="mb-2">
      <small>
        <strong>Art. 13.</strong> Antes de configurado o embarque, o passageiro terá direito ao reembolso do valor pago pelo
        bilhete, em até 30 (trinta) dias do pedido, bastando para tanto a sua simples declaração de vontade por meio
        de formulário fornecido pela transportadora.
      </small>
    </p>
    <p className="mb-0">
      <small>
        <strong>§ 1º</strong> Para efeito de reembolso do valor pago pelo bilhete dos serviços de transporte rodoviário de
        passageiros, considera-se configurado o embarque 3 (três) horas antes do horário do início da viagem
        constante do bilhete de passagem.
      </small>
    </p>
  </React.Fragment>
)

export class FormularioSolicitacaoReembolso extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      componentRef: React.createRef()
    }
  }

  imprimir () {
    window.print()
  }

  componentDidMount () {
    if (!this.props.empresaSelecionada.id) {
      this.props.history.push('/painel-remarcacao')
      return
    }
    const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true })
    if (!parametros.reserva) {
      this.props.history.push('/painel-remarcacao')
      return
    }
    this.props.buscarReserva(parametros.reserva, this.props.empresaSelecionada.id)
      .then((action) => {
        const payload = action && action.payload
        const reserva = payload && payload.data
        if (!reserva) {
          showErrorMsg('Reserva não encontrada.')
          this.props.history.push('/painel-remarcacao')
          return
        }
        if (reserva.situacaoReserva !== 'REEMBOLSO_SOLICITADO') {
          showErrorMsg('A reserva não está com reembolso solicitado.')
          this.props.history.push('/painel-remarcacao')
        }
      })
      .catch(() => {
        showErrorMsg('Não foi possível carregar a reserva.')
        this.props.history.push('/painel-remarcacao')
      })
  }

  valorTotalBilhete (reserva) {
    if (!reserva) return '0'
    const base = Number(reserva.valor || 0)
    const taxa = Number(reserva.taxaEmbarque || 0)
    return formatarReal((base + taxa).toString())
  }

  textoOuLinha (valor) {
    if (valor !== undefined && valor !== null && String(valor).trim() !== '') {
      return <span className="text-break">{valor}</span>
    }
    return <span className="text-muted">_______________________________________________</span>
  }

  exibirCabecalhoEmpresa (reserva) {
    const emp = reserva.dadosEmpresa
    const nome = emp ? emp.nomeEmpresa : this.props.empresaSelecionada.nome
    const cnpj = emp ? emp.cnpjEmpresa : this.props.empresaSelecionada.cnpj
    if (emp) {
      return (
        <address className="mb-3 ml-1">
          <strong className="d-block text-center" style={{ fontSize: '1.1rem' }}>{nome}</strong>
          {cnpj && <span className="d-block text-center"><strong>CNPJ:</strong> {cnpj}</span>}
          <span className="d-block text-center text-break">
            {`${emp.logradouro}, ${emp.numero || 'S/N'}${emp.complemento ? `, ${emp.complemento}` : ''}`}
            <br />
            {`${emp.bairro} - ${emp.localidade} - ${emp.uf}`}
            <br />
            <strong>CEP:</strong> {emp.cep}
          </span>
        </address>
      )
    }
    return (
      <div className="mb-3 text-center">
        <strong style={{ fontSize: '1.1rem' }}>{nome}</strong>
        {cnpj && <div><strong>CNPJ:</strong> {cnpj}</div>}
      </div>
    )
  }

  exibirFormulario (reserva, via) {    
    const p = reserva.passageiroDto
    const origem = reserva.descCidadeOrigemAlternativa || reserva.descCidadeOrigem
    const destino = reserva.descCidadeDestinoAlternativa || reserva.descCidadeDestino
    const linha = [reserva.rota, reserva.prefixoRota].filter(Boolean).join(' — ') || reserva.idRota || '—'
    const fone = p && (p.ddi || p.telefone)
      ? `${p.ddi ? `${p.ddi} ` : ''}${p.telefone || ''}`.trim()
      : null
    const multa = reserva.custoCancelamento != null
      ? formatarReal(String(reserva.custoCancelamento))
      : '—'
    const valorReembolso = reserva.valorEstorno != null
      ? formatarReal(String(reserva.valorEstorno))
      : '—'
    const motivo = reserva.observacao

    return (
      <div className="kloai mt-2" style={{ border: '1px solid' }}>
        <div className="invoice-title text-center px-2 pt-3">
          <h5 className="font-weight-bold text-uppercase mb-3">
            Formulário de solicitação de reembolso de passagem
          </h5>
          {this.exibirCabecalhoEmpresa(reserva)}
        </div>
        <hr />
        <div className="px-3 pb-3" style={{ fontWeight: 'bold' }}>
         {via && <div className="row mb-2">
              <div className="col-md-12">
                    <strong><span className="text-break">{via}</span></strong>
                </div>
          </div>}
          <div className="row mb-2">
            <div className="col-md-12">
              <strong>Linha:</strong> <span className="text-break">{linha}</span>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6">
              <strong>Origem:</strong> <span className="text-break">{origem}</span>
            </div>
            <div className="col-md-6">
              <strong>Destino:</strong> <span className="text-break">{destino}</span>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6">
              <strong>Data da viagem:</strong> {reserva.dataHoraPartida || '—'}
            </div>
            <div className="col-md-6">
              <strong>Data de emissão:</strong> {reserva.dataVenda || '—'}
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6">
              <strong>Número do bilhete:</strong> {reserva.id}
            </div>
            <div className="col-md-6">
              <strong>Valor:</strong> {this.valorTotalBilhete(reserva)}
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6">
              <strong>Valor da multa / taxa:</strong> {multa}
            </div>
            <div className="col-md-6">
              <strong>Valor a ser reembolsado:</strong> {valorReembolso}
            </div>
          </div>
          <hr />
          <div className="row mb-2">
            <div className="col-md-12">
              <strong>Nome do(a) passageiro(a):</strong>{' '}
              {p ? this.textoOuLinha(p.nome) : this.textoOuLinha(null)}
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6">
              <strong>CPF:</strong> {p ? this.textoOuLinha(p.cpfPassageiro) : this.textoOuLinha(null)}
            </div>
            <div className="col-md-6">
              <strong>Documento com foto:</strong> {p ? this.textoOuLinha(p.documentoComFoto) : this.textoOuLinha(null)}
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-12">
              <strong>Fone:</strong> {this.textoOuLinha(fone)}
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-12">
              <strong>Motivo do cancelamento:</strong>
              <div className="mt-1 font-weight-normal text-break border rounded p-2" style={{ minHeight: '4rem' }}>
                {this.textoOuLinha(motivo)}
              </div>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6">
              <strong>Forma de restituição:</strong> {this.textoOuLinha(reserva.formaRestituicao)}
            </div>
            <div className="col-md-6">
              <strong>Data do pedido de reembolso:</strong> {this.textoOuLinha(reserva.dataPedidoReembolso || reserva.dataSolicitacaoReembolso)}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-12">
              <strong>Agência emissora:</strong>{' '}
              <span className="text-break">
                {this.textoOuLinha(reserva.nomeAgencia || reserva.descricaoAgencia || reserva.codigoAgencia)}
              </span>
            </div>
          </div>
          <hr />
          <div className="font-weight-normal mb-3">
            {TEXTO_LEGAL_REEMBOLSO}
          </div>
          <div className="row mt-4">
            <div className="col-md-6 text-center">
              <div style={{ borderBottom: '1px solid #000', minHeight: '1.5rem', marginBottom: '0.25rem' }} />
              <small>{reserva.dadosEmpresa ? reserva.dadosEmpresa.nomeEmpresa : this.props.empresaSelecionada.nome}</small>
            </div>
            <div className="col-md-6 text-center">
              <div style={{ borderBottom: '1px solid #000', minHeight: '1.5rem', marginBottom: '0.25rem' }} />
              <small>{p ? p.nome : 'Assinatura do(a) passageiro(a)'}</small>
            </div>
          </div>
          {/* <div className="text-right mt-3">
            <small className="text-muted">Página: 1 / 1</small>
          </div> */}
        </div>
      </div>
    )
  }

  exibirBotoes () {
    return (
      <div className="row justify-content-md-center mt-2" id="printPageButton">
        <Link className="ml-2" to="/painel-remarcacao">
          <button type="button" className="btn btn-sm btn-laranja">Concluir</button>
        </Link>
        <button
          type="button"
          className="btn btn-sm btn-laranja ml-2"
          onClick={() => this.imprimir()}
        >
          <i
            className="material-icons mr-1"
            style={{ fontSize: '18px', verticalAlign: 'middle' }}
          >
            &#xe8ad;
          </i>
          Imprimir
        </button>
      </div>
    )
  }

  render () {
    const { reserva } = this.props
    if (!reserva) {
      return ''
    }
    return (
      <React.Fragment>
        <div className="grid invoice">
          {this.exibirBotoes()}
          <div
            ref={this.state.componentRef}
            className="grid-body mt-4"
            id="formulario-reembolso-passagem"
            style={{ fontSize: 16, fontWeight: 'bold' }}
          >
            {this.exibirFormulario(reserva)}
            {this.exibirFormulario(reserva, 'Via agência')}
          </div>
          {this.exibirBotoes()}
        </div>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = state => ({
  empresaSelecionada: state.empresaSelecionada,
  reserva: state.reserva
})

export default withRouter(connect(mapStateToProps, { buscarReserva })(FormularioSolicitacaoReembolso))
